














































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import numeral from 'numeral';

@Component
export default class GoodsDetailModal extends Vue {
    @Prop({ default: false })
    private visible!: boolean;

    @Prop({ default: () => ({}) })
    private item!: any;

    private close() {
        this.$emit('close');
    }

    private formatCurrency(val: number): string {
        if (!val) return '0 đ';
        return numeral(val).format('0,0') + ' đ';
    }
}
